import SerpBulkStockAdjustmentSnapshot from '@/components/Approval/@components/SerpBulkStockAdjustment/Snapshot';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 210 SERP 재고실사 조정(다중) — 저장 content 그대로, 「내역 보기」는 content 안 매장별 상세 */
const SerpBulkStockAdjustmentSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpBulkStockAdjustmentSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpBulkStockAdjustmentSlot;
